export const EXCLUDED_RESOURCES: ReadonlySet<string> = new Set(['account', 'broker', 'realm-management']);
